//
//
//
//
//
//

export default {
  name: 'SubscribeHero2026PromoVideo',
  data() {
    return {
      promoVideoPath: '/img/subscribe/subscription-ai-remix-2026.260721.mp4',
    };
  },
  mounted() {
    if (this.$refs.video) {
      this.$refs.video.play().catch(() => {
        // Handle or ignore autoplay block
      });
    }
  },
};
